<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="windowItems"
      item-key="id"
      show-expand
      single-expand
      :expanded.sync="expanded"
      hide-default-footer
      class="mt-3"
      @click:row="onRowClick"
    >
      <template v-slot:[`item.window`]="{ item }">
        <span
          >{{ item.series_name || "N/A" }}, {{ item.type_name || "N/A" }}</span
        >
      </template>
      <template v-slot:[`item.glass`]="{ item }">
        <span
          >{{ item.glass.glass_type }}, {{ item.glass.glass_tint }},
          {{ item.glass.glass_patten }}, {{ item.glass.glass_thickness }},
          {{ item.glass.installation_elevation }},
          {{ item.glass.min_thickness }}</span
        >
        <template v-if="item.glass.addons && item.glass.addons.length > 0">
          <span> (Addons: {{ getGlassAddons(item.glass.addons) }})</span>
        </template>
      </template>
      <template v-slot:[`item.grid`]="{ item }">
        <span
          >{{ item.grid.pattern }}, {{ item.grid.color }}, {{ item.grid.size }},
          {{ item.grid.type }}</span
        >
      </template>
      <template v-slot:[`item.color`]="{ item }">
        <span
          >{{ item.color.exterior_color }} Over
          {{ item.color.interior_color }}</span
        >
      </template>
      <template v-slot:[`item.frame`]="{ item }">
        <span>{{ (item.frame.type && item.frame.type) || "N/A" }}</span>
      </template>
      <template v-slot:[`item.size`]="{ item }">
        <span> Width: {{ item.size.width }}, </span>
        <span> Height: {{ item.size.height }}, </span>
        <span> Sill Height: {{ item.size.sill_height }} </span>
      </template>
      <template v-slot:[`item.performance`]="{ item }">
        <template
          v-if="
            item.testing_results && Object.keys(item.testing_results).length > 0
          "
        >
          <span>
            {{
              item.testing_results.performance_grade &&
                `Performance Grade: ${item.testing_results.performance_grade}`
            }}
            {{
              item.testing_results.SHGC &&
                `, SHGC: ${item.testing_results.SHGC}`
            }}
            {{
              item.testing_results.STC && `, STC: ${item.testing_results.STC}`
            }}
            {{
              item.testing_results.OITC &&
                `, OITC: ${item.testing_results.OITC}`
            }}
            {{
              item.testing_results["U-factor"] &&
                `, U-factor: ${item.testing_results["U-factor"]}`
            }}
          </span>
        </template>
        <span v-else>N/A</span>
      </template>
      <template v-slot:[`item.reports`]="{ item }">
        <template v-if="item.reports && Object.keys(item.reports).length > 0">
          <span>
            {{ item.reports.AAMA && `AAMA: ${item.reports.AAMA}` }}
            {{ item.reports.NFRC && `, NFRC: ${item.reports.NFRC}` }}
            {{ item.reports.STC && `, STC: ${item.reports.STC}` }}
          </span>
        </template>
        <span v-else>N/A</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <!-- v-if="item.config_id" -->
        <v-icon
          color="primary"
          @click.stop="editWindow(item)"
          >mdi-pencil</v-icon
        >
        <v-icon color="success" @click.stop="submitTicket(item)"
          >mdi-face-agent</v-icon
        >
      </template>
      <template v-slot:[`item.data-table-expand`]="{ item, isExpanded }">
        <template v-if="item.children">
          <v-icon @click.stop="handleExpansion(item, isExpanded)">{{
            isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon>
        </template>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td v-if="item.children" :colspan="headers.length">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Mark
                  </th>
                  <th class="text-left">
                    Level
                  </th>
                  <th class="text-left">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="child in item.children"
                  :key="child.id"
                  @click="onRowClick(child)"
                >
                  <td class="text-left">
                    {{ child.mark }}
                  </td>
                  <td class="text-left">
                    {{ child.level_name }}
                  </td>
                  <td class="text-left">
                    <v-icon
                      v-if="child.config_id"
                      color="primary"
                      @click.stop="editWindow(child)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon color="success" @click.stop="submitTicket(child)"
                      >mdi-face-agent</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
      </template>
    </v-data-table>

    <CreateTicket
      v-if="ticketModal && selectedItem"
      :dialog="ticketModal"
      :item="selectedItem"
      :version="version"
      @close="ticketModal = false"
    />

    <PlayCanvas
      v-if="canvasModal && selectedItem"
      :dialog="canvasModal"
      :item="selectedItem"
      :version="version"
      @close="canvasModal = false"
    />
  </div>
</template>

<script>
import PlayCanvas from "@/components/schedule/PlayCanvas";
import CreateTicket from "@/components/ticket/CreateTicket";
export default {
  components: {
    PlayCanvas,
    CreateTicket
  },
  props: {
    items: {
      type: Array,
      default: null
    },
    windowItems: {
      type: Array,
      default: null
    },
    version: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ticketModal: false,
      canvasModal: false,
      selectedItem: false,
      expanded: [],
      headers: [
        { text: "Mark", value: "mark" },
        { text: "Level", value: "level_name" },
        { text: "Window", value: "window" },
        { text: "Glass", value: "glass" },
        { text: "Grid", value: "grid" },
        { text: "Color", value: "color" },
        { text: "Frame", value: "frame" },
        { text: "Size", value: "size" },
        { text: "Performance", value: "performance" },
        { text: "Reports", value: "reports" },
        { text: "Actions", value: "actions" }
      ]
      // items: [
      //   {
      //     id: 1,
      //     mark: "A3",
      //     level: "A3",
      //     window: ["series_name"],
      //     glass: "glass_tinit",
      //     color: "blue",
      //     frame: "frame",
      //     performance: "performance",
      //     est_cost: 349,
      //     status: "Active"
      //   }
      // ]
    };
  },
  methods: {
    getGlassAddons(addons) {
      const names = addons.map(item => item.name);
      return names.toString();
    },
    handleExpansion(item, state) {
      if (
        this.expanded.length === 1 &&
        this.expanded[0].id === item.id &&
        state
      ) {
        this.expanded = [];
        return false;
      } else {
        this.expanded = [];
        this.expanded.push(item);
        return true;
      }
    },
    onRowClick(row) {
      this.$emit("selectedWindow", row);
    },
    submitTicket(item) {
      this.selectedItem = { ...item };
      this.ticketModal = true;
    },
    editWindow(item) {
      this.selectedItem = { ...item };
      this.canvasModal = true;
    }
  }
};
</script>
